/**
 * Import STRICH SDK via ES6 import clause. It is recommended to pin a specific version, especially for
 * business-critical applications. Otherwise you can use 'latest' as the version specifier.
 */
// import {
//   StrichSDK,
//   BarcodeReader,
// } from "https://cdn.jsdelivr.net/npm/@pixelverse/strichjs-sdk@1.10.0";

import { StrichSDK, BarcodeReader } from "@pixelverse/strichjs-sdk";

/**
 * Store the scanned code in the session storage and search for products.
 * @param {Object} codeDetection - The detected barcode data.
 */
async function handleCodeDetection(codeDetection) {
  sessionStorage.setItem("scannedCode", codeDetection.data);
  console.log("Scanned code:", codeDetection.data);

  try {
    // Use Shopify's Ajax Search API to get results as JSON.
    const response = await fetch(
      `/search?q=${codeDetection.data}&type=product&view=json`,
    );
    if (!response.ok) throw new Error("Network response was not ok");
    const results = await response.json();

    // If exactly one product is found, go directly to its page.
    if (results.results_count === 1) {
      window.location.href = results.results[0].url;
    } else {
      // Otherwise, go to the standard search results page.
      window.location.href = `/search?q=${codeDetection.data}&type=product`;
    }
  } catch (error) {
    console.error(
      "[Scanner] Failed to fetch search results, falling back:",
      error,
    );
    window.location.href = `/search?q=${codeDetection.data}&type=product`;
  }
}

/**
 * Initialize STRICH BarcodeReader and start scanning.
 */
async function initializeBarcodeReader() {
  // see https://docs.strich.io/reference/interfaces/Configuration.html for all available options
  let configuration = {
    selector: "#strich-barcode-scanner-host",
    frameSource: {
      resolution: "full-hd",
    },
    engine: {
      symbologies: ["ean13", "ean8", "upca", "upce", "code128", "code39", "qr"],
      duplicateInterval: 1500,
    },
  };

  // initialize BarcodeReader and start scanning barcodes.
  const barcodeReader = await new BarcodeReader(configuration).initialize();
  barcodeReader.detected = async (detections) => {
    barcodeReader.destroy();
    await handleCodeDetection(detections[0]);
  };
  await barcodeReader.start();
}

export async function initializeHeaderScanner() {
  const openBtn = document.getElementById("open-barcode-scanner");
  const closeBtn = document.getElementById("close-barcode-scanner");
  const modal = document.getElementById("barcode-scanner-modal");

  if (!openBtn || !closeBtn || !modal) return;

  openBtn.addEventListener("click", () => {
    console.log("open barcode scanner");
    modal.classList.remove("hidden");
    initializeBarcodeReader();
  });

  closeBtn.addEventListener("click", () => {
    modal.classList.add("hidden");
    // Note: The barcode reader is destroyed after each scan, so no need to stop it here.
  });
}

/**
 * Handle initialization error. All exceptions thrown by the SDK are of type SdkError:
 * https://docs.strich.io/reference/classes/SdkError.html
 *
 * This is just for illustration, in a production app you would not be using window.alert().
 */
function handleInitializationError(err) {
  let message = err.message;
  if (err.detailMessage) {
    // some errors contain additional details in the detailMessage property
    message += "\n" + err.detailMessage;
  }
  window.alert(`Initialization failed: ${message}`);
}

/**
 * Initialize STRICH SDK and BarcodeReader.
 * This function handles the async initialization process.
 */
async function initializeStrichSDK() {
  const licenseKey =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyNzZmYjA1NC01YzVjLTQ3ZjktOTFjZC05YTQyNTIzZjAwMDIiLCJpc3MiOiJzdHJpY2guaW8iLCJhdWQiOlsiaHR0cHM6Ly9vdGwtcHJvZHVjdGlvbi5teXNob3BpZnkuY29tLyJdLCJpYXQiOjE3Njg1NzIyMTEsIm5iZiI6MTc2ODU3MjIxMSwiY2FwYWJpbGl0aWVzIjp7fSwidmVyc2lvbiI6MX0.EhQlgjn_TDwZjtimvTnoxd1zwY4iKHXkjnoiKkMFx4w";

  try {
    await StrichSDK.initialize(licenseKey);
    await initializeBarcodeReader();
  } catch (err) {
    // handleInitializationError(err);
  }
}

// Initialize the SDK when the module loads.
initializeStrichSDK();
